import { StockInformationViewObject, StockLocationTypeViewObject } from '@/types/apiServerContract';
import dictionaryService from '@/core/translation/dictionary.service';

const ProductDeliveryCodes = new Map<StockLocationTypeViewObject, string>(
    [
        [StockLocationTypeViewObject.Local, 'Product.Delivery.Local'],
        [StockLocationTypeViewObject.Remote, 'Product.Delivery.Remote'],
        [StockLocationTypeViewObject.InComing, 'Product.Delivery.InComing']
    ]
);

class ProductDeliveryService {
    public getProductDeliveryCodeDictionary(stock: readonly StockInformationViewObject[]): string | null {
        if (!stock || stock.length === 0) return null;

        const isLocal = stock.some(x => x.locationType === StockLocationTypeViewObject.Local);
        const isRemote = stock.some(x => x.locationType === StockLocationTypeViewObject.Remote);
        const isIncoming = stock.some(x => x.locationType === StockLocationTypeViewObject.InComing);

        if (!isLocal && !isRemote && !isIncoming) {
            return null;
        }

        const stockType = isLocal ? StockLocationTypeViewObject.Local : isRemote ? StockLocationTypeViewObject.Remote : isIncoming ? StockLocationTypeViewObject.InComing : null;
        if (stockType == null) {
            return null;
        }

        const productDeliveryCode = ProductDeliveryCodes.get(stockType);
        if (!productDeliveryCode) { throw new Error(`Unknown delivery for stock type ${stockType}!`); }

        return dictionaryService.get(productDeliveryCode);
    }
}

export default new ProductDeliveryService();
